import React, { forwardRef } from 'react'
import { useContext } from 'sb-hooks'

import { Collapsible } from 'components/_new/layout'

import { AccordionItemContext } from './AccordionItem'


type AccordionPanelProps = React.HTMLAttributes<HTMLDivElement> & {
  className?: string
  id?: string
}


const AccordionPanel = forwardRef<HTMLDivElement, AccordionPanelProps>((props, ref) => {
  const { className, id, ...rest } = props
  const { state } = useContext(AccordionItemContext)

  return (
    <Collapsible
      className={className}
      id={id}
      opened={state.isOpen}
    >
      <div
        id={state.panelId}
        aria-labelledby={state.buttonId}
        role="region"
        ref={ref}
        {...rest}
      />
    </Collapsible>
  )
})


export default AccordionPanel
